/**
 * Regra de comissão MÍNIMA garantida para CONSULTORES em período de experiência.
 *
 * Regra fixa: o consultor que está em `contratos_experiencia` cobrindo o mês de
 * competência avaliado ganha comissão SEM precisar bater meta, com os percentuais
 * abaixo aplicados sobre o faturamento ATIVO de cada categoria.
 *
 * Se ele bateu meta E a comissão pela faixa normal for MAIOR, recebe o maior
 * dos dois (não pode ser punido por bater meta).
 *
 * Esta regra:
 * - Aplica APENAS para `cargo === 'CONSULTOR'`
 * - É AUTOMÁTICA e por mês (nada a configurar — depende só do contrato em `contratos_experiencia`)
 * - Não altera nenhuma regra/faixa/meta existente
 */
export const PERCENTUAIS_EXPERIENCIA = {
  pn: 150,
  ha: 50,
  fibra: 50,
  tt: 10,
  ttpre: 10,
  mp: 10,
} as const;
